import React, { useEffect } from "react"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { useAddCommentMutation } from "appRedux/slices/wishItemApiSlice"
import { wishItemCommentSchema } from "validations/wishItem"
import CommentTextField from "components/atoms/CommentTextField"

type AddCommentInputProps = {
  id: number;
}

export default function AddCommentInput({ id }: AddCommentInputProps) {
  const [triggerAddComment, addCommentResult] = useAddCommentMutation()

  const {
    register,
    getValues,
    setValue,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<WishItemCommentRequestPayload>({
    resolver: zodResolver(wishItemCommentSchema),
    shouldFocusError: false,
    reValidateMode: "onBlur",
    defaultValues: { content: "" }
  })

  useEffect(() => {
    if (!Object.keys(errors).length) return
    console.log("errors", errors)
  }, [errors])

  useEffect(() => {
    if (addCommentResult.status === "fulfilled") {
      reset({ content: "" })
    }
  }, [addCommentResult.status])

  function handleAddComment(value: WishItemCommentRequestPayload) {
    triggerAddComment({ id: id, body: value })
  }

  return (
    <>
      <form onSubmit={handleSubmit(handleAddComment)} style={{ width: "100%" }}>
        <CommentTextField
          id="content"
          defaultValue={getValues("content")}
          register={register}
          setValue={setValue}
          onSubmit={handleSubmit(handleAddComment)}
        />
      </form>
    </>
  )
}
